import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-responsive-modal';
import { setPopup } from '../../../redux/messageSlice';
import { DELETE_MSG_MUTATION } from '../../../apollo/Mutations';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast'

const DeleteMessage = () => {
    const dispatch = useDispatch()
    const { user, delete_msg, active_msg } = useSelector(state => state.message);

    const [deleteMutaion] = useMutation(DELETE_MSG_MUTATION)
    const deleteMsgMethod = (delete_type) => {
        try {
            deleteMutaion({
                variables: {
                    input: {
                        conversation_id: active_msg?.conversation_id,
                        msg_id: active_msg?.msg_id,
                        delete_type: delete_type,
                        is_reply_msg: active_msg?.is_reply_msg,
                        participants: active_msg?.participants
                    }
                }
            });
            toast.success('Message deleted!');
            dispatch(setPopup({ key: 'delete_msg', value: false }))
            // dispatch(delete_single_item_form_array({ state_key: data.is_reply_msg === 'yes' ? 'reply_msgs' : 'msgs', item_key: 'msg_id', value: data.msg_id }))
            // closePopUp();
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Modal
            open={delete_msg}
            onClose={() => dispatch(setPopup({ key: 'delete_msg', value: false }))}
            center
            // closeIcon={<MdClose className="text-3xl mt-1 text-teal-600 dark:text-white  dark:text-white" />}
            closeIcon={<div className="deleteCloseIcon text-3xl mt-1 text-teal-600 dark:text-white" />}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal bgSurfaceDarkMainBox',
            }}
            container={document.getElementById('root')}
        >
            <div className="flex items-center justify-center">
                <div className="">
                    <h2 className="text-lg text-teal-600 dark:text-white">Delete message</h2>
                    <p className="mt-2 text-sm text-grey-600 dark:text-white">
                        Delete this message? It will be removed from your view only—others in the conversation will still see it. This action cannot be 
                        <span className="undone"> undone</span>.
                    </p>
                    <div className="mt-4 flex flex-col gap-2.5">
                        <button className="px-4 py-2.5 bg-red-600 text-sm text-white rounded-md" onClick={() => deleteMsgMethod('for_me')}> Delete </button>
                        {/* {active_msg?.sender === user?.id && <button className="px-4 py-2.5 bg-red-600 text-sm text-white rounded-md" onClick={() => deleteMsgMethod('for_all')}> Delete for all </button>} */}
                        <button onClick={() => dispatch(setPopup({ key: 'delete_msg', value: false }))} className="px-4 py-2.5 bg-teal-600 text-white text-sm rounded-md dark:text-white dark:border dark:border-white bgSurfaceDark"> Cancel </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteMessage;